import * as React from 'react';
import { SVGProps } from 'react';

const IconLinkSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M4 4a4 4 0 1 0 0 8h3v-2H4a2 2 0 1 1 0-4h3V4H4ZM12 4H9v2h3a2 2 0 1 1 0 4H9v2h3a4 4 0 0 0 0-8Z" />
    <path d="M11 7H5v2h6V7Z" />
  </svg>
);
export default IconLinkSizeS;
